export default {"src":"/_next/static/media/arcticons_healthy-cities.0ef3d328.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};